<div
  class="modal fade disbursement-revision-dialog"
  [class.disbursement-revision-dialog-stacked]="stackAboveModal"
  [id]="modalId"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered disbursement-revision-dialog-container">
    <div class="modal-content disbursement-revision-dialog-content">
      <div class="disbursement-revision-dialog-header">
        <h5 class="disbursement-revision-dialog-title">{{ title }}</h5>
        <button
          type="button"
          class="btn-close"
          aria-label="ปิด"
          [disabled]="isProcessing"
          (click)="onCancel()"
        ></button>
      </div>

      <form [formGroup]="form" class="disbursement-revision-dialog-body" (ngSubmit)="onSubmit()">
        <app-textarea
          label="เหตุผล"
          formControlName="reason"
          [rows]="5"
          [required]="true"
          [error]="form.controls.reason.invalid && form.controls.reason.touched ? form.controls.reason.errors : null"
        ></app-textarea>

        <div class="disbursement-revision-dialog-actions">
          <button
            type="button"
            class="btn disbursement-revision-dialog-cancel-button"
            [disabled]="isProcessing"
            (click)="onCancel()"
          >
            {{ cancelText }}
          </button>
          <button
            type="submit"
            class="btn disbursement-revision-dialog-confirm-button"
            [disabled]="isProcessing"
          >
            {{ isProcessing ? 'กำลังดำเนินการ...' : confirmText }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
